/**
 * Created by ZD on 2020/11/20.
 */
import Vue from 'vue';
import router from './../router'

export default {
  userTel: function(mobile) {
    var regExp = /(^1[3|5|6|7|8|9][\d]{9}$)|(^14[5|6|7|9]\d{8}$)/;
    if (mobile == "") {
      Vue.prototype.$msg('手机号不能为空');
      return false;
    }else if (!regExp.test(mobile)) {
      Vue.prototype.$msg('手机号格式错误');
      return false;
    }else {
      return true;
    }
  },

  /*密码判断*/
  userPwd: function (password) {
    var regExp = /^[a-zA-Z][a-zA-Z0-9~!@#$%^&*]{5,17}/;
    if (password == "") {
      Vue.prototype.$msg('密码不能为空');
      return false;
    } else if (!regExp.test(password)) {
      Vue.prototype.$msg('字母开头的6到16位字符、数字及特殊符号');
      return false;
    } else {
      return true;
    }
  },

  /*限制只能输入数字，英文, 中文，下划线*/
  check_count: function (_this) {
     _this.target.value = _this.target.value.replace(/[^\a-\z\A-\Z0-9]/g, '');
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js